import { useState, useEffect } from "react";
import RfmModalBase from "./RfmModalBase";


const DEFAULT_COLORS = [
    "#3b82f6", "#10b981", "#f59e0b", "#ef4444",
    "#8b5cf6", "#ec4899", "#06b6d4", "#84cc16",
];


export default function RfmEditZoneModal({ open, onClose, zone, onSave }) {
    const [color, setColor] = useState(DEFAULT_COLORS[0]);
    const [name, setName] = useState("");
    const [cols, setCols] = useState(50);
    const [rows, setRows] = useState(100);

    useEffect(() => {
        if (open && zone) {
            setColor(zone.color || DEFAULT_COLORS[0]);
            setName(zone.name || "");
            setCols(zone.cols || 50);
            setRows(zone.rows || 100);
        }
    }, [open, zone]);
    return (
        <RfmModalBase
            open={open}
            title="Editar Zona"
            onClose={onClose}
            footer={
                <>


                    <div className="ord-footer">
                        <button className="ord-btn ord-btn-secondary" type="button" onClick={onClose}>
                            Cancelar
                        </button>
                        <button className="ord-btn ord-btn-primary" type="button" onClick={() =>
                            onSave?.({
                                id: zone?.id,
                                name,
                                color,
                                grid_cols: Number(cols),
                                grid_rows: Number(rows),
                            })
                        }
                            disabled={!name?.trim()}>
                            <i className="bi bi-plus-lg" /> Guardar
                        </button>
                    </div>
                </>
            }
        >



            <div className="ord-form-group">
                <label className="ord-form-label">Nombre</label>
                <input className="ord-form-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Ej: Terraza" />
            </div>

            <div className="ord-form-group">
                <label className="ord-form-label">Color</label>
                <div className="ord-color-picker">
                    {DEFAULT_COLORS.map((c) => (
                        <div
                            key={c}
                            className={`ord-color-option ${color === c ? "active" : ""}`}
                            data-color={c}
                            style={{ background: c }}
                            onClick={() => setColor(c)}
                        />
                    ))}
                </div>
            </div>

            <div className="ord-form-row">
                <div className="ord-form-group">
                    <label className="ord-form-label">Columnas</label>
                    <input className="ord-form-input" type="number" min={10} max={100} value={cols} onChange={(e) => setCols(e.target.value)} />
                </div>
                <div className="ord-form-group">
                    <label className="ord-form-label">Filas</label>
                    <input className="ord-form-input" type="number" min={20} max={200} value={rows} onChange={(e) => setRows(e.target.value)} />
                </div>
            </div>
        </RfmModalBase>
    )
}